/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import {
	// eslint-disable-next-line graphql-relay-compat/no-import-apollo-functions -- Read http://go/cfe-no-import-apollo-functions
	useQuery,
} from '@apollo/react-hooks';

import { markErrorAsHandled } from '@confluence/graphql/entry-points/markErrorAsHandled.ts';
import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';
import { ConfluenceEdition } from '@confluence/change-edition/entry-points/ConfluenceEdition.ts';

export const useIsPrivacyModeEnabled = (): boolean => {
	const { cloudId, edition } = useSessionData();
	// eslint-disable-next-line graphql-client-usage/graphql-generic-types
	const { data, error } = useQuery(
		gql`
			query useIsPrivacyModeEnabledQuery($cloudId: ID!) {
				confluence_isPrivacyModeEnabled(cloudId: $cloudId) {
					isPrivacyModeEnabled
				}
			}
		`,
		{
			variables: {
				cloudId,
			},
			skip:
				!fg('ccir_privacy_mode') ||
				edition !== ConfluenceEdition.PREMIUM ||
				// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
				Boolean(process.env.REACT_SSR),
		},
	);

	if (error) {
		// We dont care about the error, thus we handle it silently
		markErrorAsHandled(error);
		// Return true to avoid any privacy leakage.
		return true;
	}

	return data?.confluence_isPrivacyModeEnabled?.isPrivacyModeEnabled ?? false;
};
